import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sortleaves',
    standalone: false
})
export class SortleavesPipe implements PipeTransform {

  transform(arr: any[]): any[] {
    if (!Array.isArray(arr)) {
      return arr;
    }
    return arr.sort((a, b) => {
      const statusOrder = ['pending', 'approved', 'rejected'];
      return statusOrder.indexOf(a.status) - statusOrder.indexOf(b.status);
    });
  }
}
